import React from 'react';
import { motion } from 'framer-motion';
import { Cloud, PieChart, CalendarRange, SearchCheck } from 'lucide-react';
const mechanisms = [{
  icon: PieChart,
  title: 'Dashboard Maestro',
  description: 'Tu salud financiera en colores, no en celdas aburridas.'
}, {
  icon: CalendarRange,
  title: 'Proyector de Cuotas',
  description: 'Mira el impacto de tus tarjetas en los meses futuros antes de hacer la próxima compra.'
}, {
  icon: SearchCheck,
  title: 'Rastreador de Fugas',
  description: 'Identifica ese gasto pequeño y repetido que te está robando las vacaciones.'
}];
export function Solution() {
  return <section className="py-10 md:py-20 bg-stone-50 border-t border-gray-100" data-id="element-159" data-mp="hwo9xz2gqj0o">
      <div className="container mx-auto px-4 md:px-6" data-id="element-160" data-mp="mtoiqhqp5zvh">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-center mb-8 md:mb-12" data-id="element-161" data-mp="2c8320miy4ujl">
          <div className="inline-flex items-center gap-1.5 md:gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-white rounded-full shadow-sm border border-gray-100 mb-4 md:mb-6" data-id="element-162" data-mp="2y3x5nv2t5hw">
            <Cloud className="w-4 h-4 md:w-5 md:h-5 text-teal-600" data-id="element-163" data-mp="brqp12w5xolt" />
            <span className="text-xs md:text-sm font-medium text-gray-600" data-id="element-164" data-mp="btjw2jaouauc">
              Vive en la nube · Lo consultas desde el celular
            </span>
          </div>
          <h2 className="font-display text-2xl md:text-4xl font-extrabold text-gray-900 tracking-tight mb-4 md:mb-6" data-id="element-165" data-mp="3g706u9q9voem">
            Un sistema listo para usar, no una planilla en blanco
          </h2>
          <div className="space-y-2 md:space-y-4 text-sm md:text-lg text-gray-600" data-id="element-166" data-mp="3p5lom2nx6zec">
            <p data-id="element-167" data-mp="19e65c1cusg7s">
              No necesitas ser experto en finanzas ni tener conocimientos
              técnicos. Orden Financiero™ ya viene configurado: solo ingresas
              tus datos y el sistema traduce tus números en algo que puedes leer
              de un vistazo.
            </p>
            <p data-id="element-168" data-mp="1ghnt6g1gchji">
              La meta no es dejar de disfrutar tu dinero. Es saber exactamente
              qué está pasando con él para poder decidir mejor.
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6 max-w-5xl mx-auto" data-id="element-169" data-mp="1qfk00vncwqbt">
          {mechanisms.map((mechanism, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08,
          duration: 0.35
        }} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4 md:p-6 flex md:flex-col items-start gap-3 md:gap-4" data-id="element-170" data-mp="sr06gomvnncw" data-mpi={index}>
              <div className="w-9 h-9 md:w-11 md:h-11 rounded-xl bg-teal-50 flex items-center justify-center flex-shrink-0" data-id="element-171" data-mp="7hf7b359e1zv">
                <mechanism.icon className="w-4 h-4 md:w-5 md:h-5 text-teal-600" data-id="element-172" data-mp="2gztybkz8uhw" />
              </div>
              <div data-id="element-173" data-mp="3tqyjgsgkrrh3">
                <h3 className="font-display text-sm md:text-lg font-bold text-gray-900 tracking-tight mb-1" data-id="element-174" data-mp="3oqappz0yowj6">
                  {mechanism.title}
                </h3>
                <p className="text-xs md:text-sm text-gray-600 leading-relaxed" data-id="element-175" data-mp="3kqjvtmg520af">
                  {mechanism.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}